<script>
  import ChatMessage from './chat-message';

  export default {
    extends: ChatMessage,

    computed: {
      /**
       * @return {Object}
       */
      call() {
        return this.message.call;
      },

      // /**
      //  * @return {Object}
      //  */
      // styles() {
      //   const {
      //     'other.item.text.color': color,
      //     'other.item.background.color': backgroundColor
      //   } = {...this.brand.styles};
      //
      //   // remove empty values
      //   return _.pickBy({color, backgroundColor}, _.identity);
      // },

      /**
       * @returns {string}
       */
      duration() {
        return _.get(this.call, 'duration_text', '-');
      },

      /**
       * @return {object|null}
       */
      beginAt() {
        return _.get(this.call, 'begin_at', null);
      },

      /**
       * @returns {string}
       */
      beginAtFormatted() {
        return this.beginAt ? this.formatTime(this.beginAt) : '';
      }
    },
  }
</script>
